export default function ContatoJudicial() {
    const contatoFormSubmit = document.querySelector('#form-submit')
    const btnSubmit = document.querySelector(".leilao-judicial .btn")

    if (!contatoFormSubmit || !btnSubmit) return;

    async function showMessage(response) {
        const message = response.data ? response.data.status : response.message
        GLOBAL.showToastify(message)

        contatoFormSubmit.reset()

        // enableDisableBtn(false)
        setTimeout(() => enableDisableBtn(false), 1000)
    }

    function enableDisableBtn(state) {
        btnSubmit.disabled = state
        btnSubmit.style.opacity = state ?  "0.5": "1.0";
    }

    function handleSubmitForm(e) {
        e.preventDefault()
        enableDisableBtn(true)
  

       
        const captchaResponse = window.grecaptcha.getResponse();
     

        if(!document.querySelector('#captcha-validade1').value){
            const response = {
                message: 'Ocorreu um erro ao enviar o formulário. Tente outra vez'
            }
            showMessage(response)
            return
        
        }

      

   

        const formValue = new FormData(e.currentTarget)
        const url = e.currentTarget.dataset.action
        axios.post(url, formValue)
        .then((response) => showMessage(response))
        .catch((response) => showMessage(response))
   
    }

    contatoFormSubmit.addEventListener('submit', handleSubmitForm);
}